function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBloggerinline = function SvgBloggerinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M12.981 11.938H8.893a.875.875 0 0 0 0 1.75h4.088a.859.859 0 0 0 .912-.875.881.881 0 0 0-.912-.875ZM11 0a11 11 0 1 0 11 11A11 11 0 0 0 11 0Zm5 12.374v.439a3.142 3.142 0 0 1-.88 2.312 3.242 3.242 0 0 1-2.327.875H9.082a3.062 3.062 0 0 1-2.327-.812A3.257 3.257 0 0 1 6 12.75V8.688a2.912 2.912 0 0 1 .819-1.875A2.814 2.814 0 0 1 9.019 6h2.472a2.623 2.623 0 0 1 2.622 2.625 9.668 9.668 0 0 1-.063 1.25c1.731.046 1.95 1.843 1.95 2.499ZM9.145 9.751H11.3a.805.805 0 0 0 .8-.813.91.91 0 0 0-.88-.938H9.145a.876.876 0 0 0 0 1.751Z",
    style: {
      fill: "#282828",
      fillRule: "evenodd"
    }
  }));
};
export default SvgBloggerinline;